// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"ta_a bhr_b bhr_bj","SubscribedPhotoblogs__link":"ta_b bhr_a bhr_r"};